module.exports = __webpack_public_path__ + "static/img/Reagan-CampbellGillard.bc30c41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Reagan-CampbellGillard.jpg
// module id = 2q44
// module chunks = 0